const { default: gql } = require('graphql-tag')

export const getSignedUrlForDownloadFileQuery = gql`
  query GetSignedUrlForDownloadFile($downloadId: ID!) {
    getSignedUrlForDownloadFile(downloadId: $downloadId)
  }
`
